import callCoseApi from '../middlewares/apiCallCose';
import guidedApiCached from '../middlewares/cache';

import type {GuidedMiddlewareRegistry} from '../models/middleware';
import historyOfSearches from './historyOfSearches';
import {mapCoseToGuidedV2} from './mapCoseToGuidedV2';
import {termForceWildcardOnEmpty} from './termForceWildcardOnEmpty';
import dropShortQuery from './dropShortQuery';
import {mapSecToGuidedV2} from './mapSecToGuidedV2';
import dropWhenTermProvided from './dropWhenTermProvided';




export const guidedMiddlewareRegistry: GuidedMiddlewareRegistry = {
  //static import:
  '@callCoseApi': async ()=>{
      return callCoseApi;
  },
  'cache': async ()=>{
      return guidedApiCached;
  },
  'historyOfSearches': async()=>{
      return historyOfSearches;
  },
  'CoseItemMapper': async()=>{
      return mapCoseToGuidedV2;
  },
  'priceAndAvailability': async()=>{
      //dynamic import, as it's only used in myschneider, so no need to load it in other apps
      const imported = await import('./priceAndAvailability');
      return imported.mapPriceAndAvailability;
  },
  'termForceWildcardOnEmpty': async()=>{
      return termForceWildcardOnEmpty;
  },
  'dropShortQuery': async()=>{
      return dropShortQuery;
  },
  'preloadedCache': async()=>{
      const imported = await import('./preloadedCache');
      return imported.preloadedCache;
  },
  // @ts-ignore
  '@MockSecAPI': async()=>{
      const imported = await import('./mockGuidedPromo');
      return imported.callSecApi; //dynamic import
  },
  // @ts-ignore
  'SecItemMapper': async()=>{
      return mapSecToGuidedV2; //static import
  },
  //@ts-ignore
  'dropWhenTermProvided': async()=>{
      return dropWhenTermProvided;
  },
};
